import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import Industry from './Industry';

export default compose(withRouter)(Industry);
